import { SpamScenarioId } from 'owa-junkmail-configuration';
import { createSpamStore } from '../actions/spamListMutatorActions';
import { getMailboxJunkEmailListByScenarioId } from 'owa-junkmail-configuration';

export default function initSpamOption(scenarioId: SpamScenarioId) {
    const spamList = getMailboxJunkEmailListByScenarioId(scenarioId);
    createSpamStore(scenarioId, spamList);
}
